import http from '@/helpers/Http';

export default {
    namespaced: true,
    actions: {
        async store({ commit }, payload) {
            const response = await http.post('aws/route53/hostedzones', payload);

            return response;
        },
        async delete({ commit }, id) {
            const response = await http.delete(`aws/route53/hostedzones/${id}`);

            return response;
        },
        async createRecord({ commit }, payload) {
            const response = await http.post('aws/route53/hostedzones/records', payload);

            return response;
        },
        async updateRecord({ commit }, payload) {
            const response = await http.patch(`aws/route53/hostedzones/records/${payload.id}`, payload);

            return response;
        },
        async deleteRecord({ commit }, id) {
            const response = await http.delete(`aws/route53/hostedzones/records/${id}`);

            return response;
        },
        async sync() {
            const response = await http.patch('aws/route53/hostedzones/sync');

            return response;
        }
    }
}